import FilteringPanel from './FilteringPanel';

export default FilteringPanel;
